import * as React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import { GlassCard } from '../glassmorphism/GlassmorphismStyles';

function OptionCardSkeleton() {
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: { xs: '140px', sm: '220px' },
        borderRadius: '32px',
        p: { xs: 2, sm: 3 },
        background: 'rgba(255,255,255,0.08)',
        boxShadow: '0 10px 30px rgba(0,0,0,0.10)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack spacing={2} alignItems='center' width='100%'>
        <Skeleton
          variant='circular'
          width={80}
          height={80}
          sx={{ transform: 'none' }}
        />

        <Skeleton
          variant='text'
          sx={{
            width: '80%',
            height: 28,
            transform: 'none',
          }}
        />

        <Skeleton
          variant='text'
          sx={{
            width: '90%',
            height: 22,
            transform: 'none',
          }}
        />
        <Skeleton
          variant='text'
          sx={{
            width: '70%',
            height: 22,
            mt: -1,
            transform: 'none',
          }}
        />
      </Stack>
    </Box>
  );
}

export default function OnboardingSkeleton() {
  return (
    <Box
      sx={{
        p: { xs: '12px', sm: 4 },
      }}
    >
      <GlassCard
        sx={{
          width: '100%',
          maxWidth: '900px',
          mx: 'auto',
          borderRadius: '40px',
          p: { xs: 3, sm: 5 },
          position: 'relative',
        }}
      >
        <Stack spacing={{ xs: 3, sm: 5 }} alignItems='center'>
          {/* CLOSE BUTTON */}
          <Skeleton
            variant='circular'
            width={40}
            height={40}
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
            }}
          />

          {/* HEADER */}
          <Skeleton
            variant='text'
            sx={{
              width: { xs: '80%', sm: 400 },
              height: 48,
              transform: 'none',
            }}
          />

          <Skeleton
            variant='text'
            sx={{
              width: { xs: '70%', sm: 300 },
              height: 24,
              transform: 'none',
            }}
          />

          {/* CARDS */}
          <Stack
            direction='row'
            spacing={{ xs: 2, sm: 4 }}
            sx={{
              width: '100%',
              justifyContent: 'center',
            }}
          >
            <OptionCardSkeleton />
            <OptionCardSkeleton />
          </Stack>

          {/* STEPPER */}
          <Box sx={{ width: '100%' }}>
            <Stack spacing={1}>
              <Skeleton
                variant='rounded'
                height={6}
                sx={{ borderRadius: '999px' }}
              />

              <Stack
                direction='row'
                justifyContent='space-between'
                sx={{ px: 1 }}
              >
                {[1, 2, 3].map((i) => (
                  <Skeleton key={i} variant='text' width={50} height={20} />
                ))}
              </Stack>
            </Stack>
          </Box>

          {/* BUTTON */}
          <Skeleton
            variant='rounded'
            sx={{
              width: { xs: 200, sm: 260 },
              height: 48,
              borderRadius: '999px',
            }}
          />
        </Stack>
      </GlassCard>
    </Box>
  );
}
